import { render, staticRenderFns } from "./review_modal.vue?vue&type=template&id=3bbf3afd&scoped=true&"
import script from "./review_modal.vue?vue&type=script&lang=js&"
export * from "./review_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbf3afd",
  null
  
)

export default component.exports